// frontend/src/components/settings/resolveOutcome.js
//
// Reports an Exact Resolve-gate commit summary on the app toast.
//
// Every gate commits with per-row isolation: a row that fails is logged
// server-side AND listed in ``summary.errors``, yet the endpoint still returns
// 200. Treating 200 as a clean success hides those failures (a "no silent
// failures" violation), so all gate ``onConfirmed`` handlers route their
// summary through here — partial failures surface as a warning, not a green
// "done". ``softWarning`` is a gate-specific non-error caveat (e.g. item costs
// skipped for an unknown currency), shown only when nothing harder failed.

import { showToast } from '../common/appToastBus';

export function showResolveOutcome(summary, t, { success, softWarning = null }) {
  const failed = summary.errors.length;
  if (failed > 0) {
    showToast(t('connectors.resolveAppliedWithErrors', { count: failed }), 'warning');
    return;
  }
  if (softWarning) {
    showToast(softWarning, 'warning');
    return;
  }
  showToast(success, 'success');
}
